// extracted by mini-css-extract-plugin
export default {"widgets":"_8019a115eccbe229","widgetWrapper":"fa3cc224f10e8dde","widget":"cc3d23ed1cc531a9"};